<template>
  <div>
    <settings-top-nav
      :seletedUserName="selectedUserInfo.username"
      :componentname="selectedUserComponent"
      :showAddButton="selectedUserComponent != 'add-user'"
      :showTopNav="selectedUserComponent == 'show-user'"
       @changeSelectedComponent="changeSelectedComponent"
    ></settings-top-nav>
    <!-- <users-top-nav v-if="showUsersTopNav()"></users-top-nav> -->
    <component
      :is="selectedUserComponent"
      :seletedUserName="selectedUserInfo.username"
      v-bind="currentProperties"
      @changeSelectedComponent="changeSelectedComponent"
    ></component>
  </div>
</template>

<script>
import AddUser from "./AddUser.vue";
import ShowUsers from "./ShowUsers.vue";
import settingsTopNav from "../users/HeaderBar.vue";
import UsersInfo from "../users/UserInfo.vue";
import showGroups from "../userGroups/ShowUserGroups.vue"
// import UsersTopNav from "../users/UsersTopNavBar.vue";

export default {
  name: "Users",
  data() {
    return {
      selectedUserComponent: "show-user",
      selectedUserInfo: {},
    };
  },
  components: {
    "add-user": AddUser,
    "show-user": ShowUsers,
    "settings-top-nav": settingsTopNav,
    "users-info": UsersInfo,
    "show-groups":showGroups
    // "users-top-nav": UsersTopNav,
  },
  methods: {
    changeSelectedComponent(compName, userInfo = {}) {
      this.selectedUserComponent = compName;
      this.selectedUserInfo = userInfo;
    },
    showUsersTopNav() {
      let comps = [
        "add-user",
        "users-info",
        "users-privileges",
        "bins-permissions",
        "catalog-permissions",
      ];
      if (comps.indexOf(this.selectedUserComponent) > -1) {
        return true;
      }
    },
  },
  computed: {
    currentProperties() {
      //Dynamically send props
      if (this.selectedUserComponent === "users-info" ||this.selectedUserComponent === "bins-permissions" ) {
        return { selectedUserID: this.selectedUserInfo._id};
      } else {
        return {};
      }
    },
  },
};
</script>


<style scoped lang="scss">
$header-background: #1a1a1a;
$border-color: 1px solid #3a3a3a;
$background: #121212;
$bg-color-on-hover: #141414;
$body-bg-color: #0d0d0d;
$dull-text-color: #757575;
$options-text-color: #9c9c9c;
$text-color: #eee;
$table-row-border: none;
$active-blue: #007bff;
</style>